import yup from '../../../config/yup';

export const leadSquaredReaderValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('leadSquaredReader'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  connectionKey: yup.string(),
  parameterizedBy: yup.string(),
  properties: yup.object().shape({
    requestBody: yup.string(),
    path: yup.string().required('Path is required'),
    httpMethod: yup.string().oneOf(['GET', 'POST', 'PUT', 'DELETE']),
  }),
});
